import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import IconPlus from '../../components/common/icon/IconPlusInCircle'
import { Page } from '../../components/common/page/Page'
import PageHeader from '../../components/common/page/header/PageHeader'
import { ItemList } from '../../components/common/list/ItemList'
import Item from './components/Item'
import GroupCreateModal from './components/GroupCreateModal'
import './ManageGroupsPage.less'
import HeadTitle from '../../components/common/head/HeadTitle'
import { useGroupListQuery } from './ManageGroupsPage.codegen'
import { Box, ButtonPrimary } from 'front-end/src/components'
import { ManageGroupsFilter } from 'front-end/src/pages/manage-groups-page/components/ManageGroupsFilter'

export const ManageGroupsPage = () => {
  const [filteredSearch, setFilteredSearch] = useState<string>('')
  const [showModal, setShowModal] = useState<boolean>(false)
  const [page, setPage] = useState<number>(1)
  const pageSize = 20

  const createGqlVariables = () => {
    const filters = [] as any[]
    if (filteredSearch) {
      filters.push({
        name: 'search',
        value: filteredSearch
      })
    }

    return {
      filters,
      limit: pageSize,
      offset: (page - 1) * pageSize
    }
  }

  const { data, loading, refetch } = useGroupListQuery({
    variables: createGqlVariables()
  })

  const groups = data?.admin?.organisation?.groups
  const groupsCount = data?.admin?.organisation?.groupsCount

  return (
    <Page className="ManageGroupsPage">
      <HeadTitle title={t`Groups`} />
      <PageHeader
        className="PageHeader"
        title={t`Groups`}
        controls={
          <ButtonPrimary
            onClick={() => setShowModal(true)}
            leftIcon={<IconPlus />}
          >
            <Trans>Create a group</Trans>
          </ButtonPrimary>
        }
      />
      <ItemList
        className="Groups__list"
        page={page}
        loading={loading}
        items={groups}
        itemsCount={groupsCount}
        header={
          <Box mb="16px">
            <ManageGroupsFilter
              setFilteredSearch={setFilteredSearch}
              setPage={setPage}
            />
          </Box>
        }
        pageSize={pageSize}
        renderItem={(group) => <Item group={group} />}
        onPageChange={(page) => setPage(page)}
        emptyState={t`No groups found`}
        mt={0}
      />
      <GroupCreateModal
        show={showModal}
        onCancel={() => {
          setShowModal(false)
        }}
        onGroupCreated={() => {
          refetch()
          setShowModal(false)
        }}
      />
    </Page>
  )
}
